/**
 * CopyableText — Reusable component that displays text with a copy icon.
 * Shows the value as inline text with a copy button next to it.
 * If value is empty or '-', renders just a dash with no copy icon.
 *
 * Usage:
 *   <CopyableText value="37ee8a19ccc9dfe4d8cede261dcd2d57adb44ca1" />
 */
import Box from '@cloudscape-design/components/box';
import CopyToClipboard from '@cloudscape-design/components/copy-to-clipboard';

interface CopyableTextProps {
  value: string;
}

export const CopyableText = ({ value }: CopyableTextProps) => {
  if (!value || value === '-') return <Box fontSize="body-s">-</Box>;

  return (
    <CopyToClipboard
      variant="inline"
      textToCopy={value}
      copyButtonAriaLabel="Copy"
      copySuccessText="Copied"
      copyErrorText="Failed"
      copyButtonText={value}
    />
  );
};
